export default {
  technicalPicturesContainer: {
    position: 'relative',
    margin: ['24px auto 44px', '24px auto 44px', '24px auto 56px', '24px auto 56px', '20px auto 64px'],
    height: ['400px', '400px', '400px', '400px', '525px'],
    width: ['100%', '100%', '50%'],
    button: {
      border: 'none',
      background: 'none',
      padding: 0,
      margin: 0,
      cursor: 'pointer',
      display: 'block',
      width: '100%',
      height: '100%'
    }
  },
  technicalPictureImage: {
    height: '100%',
    width: '100%',
    position: 'relative',
    cursor: 'pointer'
  }
};